const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();





// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};



// ------------------------------------------------------------------------
// fadeItem
// ----- BOTH
// ------------------------------------------------------------------------
const fadeItem = () => {
  $(window).on("scroll load", function (){
    $(".anim").each(function(){
      var imgPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > imgPos - windowHeight + windowHeight/10){
        $(this).addClass("fadein");
      } else {
        return;
      }
    });
  });
};



// ------------------------------------------------------------------------
// mobileMenu
// ----- BOTH
// ------------------------------------------------------------------------
const mobileMenu = () => {
  $('.st-Header_Hamburger > button, .st-Header_Slide_Close').on('click', function() {
    $(this).toggleClass("opened");
    $(this).parent().toggleClass("opened");
    $(".st-Header_Slide").toggleClass("menu_open");
    $(".st-Header_Slide_Inner").toggleClass("menu_open");
  });
};



// ------------------------------------------------------------------------
// scrollStar
// ----- BOTH
// ------------------------------------------------------------------------
const scrollStar = () => {
  $(window).on('scroll', function(){
    var scrollTop = $(window).scrollTop();
    var bgPosition = scrollTop / 20;
    if(bgPosition){
      $("#style").html('body:after{background-position: center top -'+ bgPosition + 'px; }');
    }
  });
};

// preload
const preload = () =>{
  $(window).on('load' , function() {
    $("body").removeClass("preload");
    $(".idx-Main").addClass("loaded");
  });
};

export {
  preload,
  anchorLink,
  fadeItem,
  mobileMenu,
  scrollStar
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js